export const headings = [
  {
    name: 'Date',
    orderable: true,
    field: 'CreatedDate',
    width: '9%',
  },
  {
    name: 'Internal Owner',
    width: '10%',
  },
  {
    name: 'Third Party',
    width: '16%',
  },
  {
    name: 'Due Dilligence Type',
    width: '16%',
    filter: {
      title: 'Filter by dd type',
      field: 'thirdPartyDueDiligenceTypes',
      options: [
        { name: 'Screening', value: 'Screening' },
        { name: 'Due Diligence', value: 'Due Diligence' },
      ],
      height: '220px',
    },
  },
  {
    name: 'Due Dilligence Level',
    width: '16%',
    filter: {
      title: 'Filter by dd level',
      field: 'thirdPartyDueDiligenceLevel',
      options: [
        { name: 'Self Service', value: 'Self Service' },
        { name: 'Managed Service', value: 'Managed Service' },
      ],
      height: '220px',
      width: '300px',
    },
  },
  {
    name: 'Status',
    width: '16%',
    filter: {
      title: 'Filter by approval status',
      field: 'approvalStatus',
      options: [
        {
          name: 'Incomplete - (Unresolved matches)',
          value: 'Incomplete - (Unresolved matches)',
        },
        {
          name: 'Incomplete - (Monitoring Alert)',
          value: 'Incomplete - (Monitoring Alert)',
        },
        { name: 'Next Review Date', value: 'Next Review Date' },
        { name: 'Report ready for review', value: 'Report ready for review' },
        {
          name: 'Updated report ready for review',
          value: 'Updated report ready for review',
        },
      ],
      height: '280px',
      width: '300px',
    },
  },
];
